import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util/strings'

const button = theme => css`
  min-height: ${rem(40)};
  background-color: ${theme.color.monochrome.superLight};
  border-radius: 0 0 ${rem(6)} ${rem(6)};
  span {
    font-size: ${theme.fontSize.x2large};
  }
`

export const styles = {
  button,
}
